import { render } from "./ZugangsdatenAendern.vue?vue&type=template&id=f5fe3046"
import script from "./ZugangsdatenAendern.vue?vue&type=script&lang=js"
export * from "./ZugangsdatenAendern.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__